import React, { useEffect } from "react";
import axios from "axios";
import { useCruise } from "../context/CruiseContext";
import { getSessionId } from "../lib/session";
import { useLocation } from "react-router-dom";
import { useSeo } from "../lib/seo";
import Navbar from "./Navbar";
import Hero from "./Hero";
import DJs from "./DJs";
import Honoree from "./Honoree";
import LaunchParty from "./LaunchParty";
import Hotel from "./Hotel";
import Suncebeat from "./Suncebeat";
import Experience from "./Experience";
import Gallery from "./Gallery";
import Destinations from "./Destinations";
import Itinerary from "./Itinerary";
import Pricing from "./Pricing";
import GroupBooking from "./GroupBooking";
import Community from "./Community";
import CTASection from "./CTASection";
import FAQ from "./FAQ";
import PackingChecklist from "./PackingChecklist";
import TermsSection from "./TermsSection";
import CrossPromote from "./CrossPromote";
import Newsletter from "./Newsletter";
import Footer from "./Footer";
import EarlyBirdBanner from "./EarlyBirdBanner";
import MobileBookCTA from "./MobileBookCTA";
import TawkChat from "./TawkChat";
import AssistantChat from "./AssistantChat";
import { Toaster } from "./ui/sonner";

const SiteLayout = () => {
  const { EVENT } = useCruise();

  useSeo(useLocation().pathname);

  // Track live presence so the /admin Live Monitor can chime on new visitors.
  useEffect(() => {
    const api = `${process.env.REACT_APP_BACKEND_URL}/api`;
    const sid = getSessionId();
    const ping = () =>
      axios
        .post(`${api}/presence/visit`, { session_id: sid, cruise: EVENT.id, path: window.location.pathname })
        .catch(() => {});
    ping();
    const t = setInterval(ping, 45000);
    return () => clearInterval(t);
  }, [EVENT.id]);

  return (
    <div className="bg-[#0A0A0A] min-h-screen pb-14 lg:pb-0">
      <Navbar />
      <Hero />
      <Honoree />
      <DJs />
      <LaunchParty />
      <Hotel />
      <Experience />
      <Gallery />
      <Destinations />
      <Suncebeat />
      <Itinerary />
      <Pricing />
      <GroupBooking />
      <Community />
      <CTASection />
      <PackingChecklist />
      <FAQ />
      <TermsSection />
      <CrossPromote />
      <Newsletter />
      <Footer />
      <EarlyBirdBanner />
      <MobileBookCTA />
      <TawkChat />
      <AssistantChat />
      <Toaster position="top-center" richColors />
    </div>
  );
};

export default SiteLayout;
